const styles = theme => ({
  buttonsContainer: {
    paddingRight: theme.spacing(2),
    borderTop: `1px solid #DAE2D9`,
    textAlign: "right",
    width: "100%",
    padding: `${theme.spacing(1)}px 0`
  },
  buttonNext: {
    marginLeft: theme.spacing(1)
  },
  backButton: {
    color: [theme.palette.primary.default, "!important"]
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/dialogs/ResetPassword/styles.js